export default "__VITE_ASSET__885cd76a__"